import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const MicOffFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M7.3 14.38c-.4-.71-.63-1.51-.63-2.37a.77.77 0 0 0-.77-.77c-.42 0-.77.35-.77.77 0 1.28.39 2.48 1.05 3.49l1.12-1.12ZM12 15.65a3.9 3.9 0 0 0 3.89-3.89V9.22l3.91-3.91c.3-.3.3-.79 0-1.1-.3-.3-.79-.3-1.1 0L4.33 18.59a.78.78 0 0 0 .55 1.33c.2 0 .4-.08.55-.23l2.44-2.44c.96.7 2.1 1.17 3.36 1.31v2.37c0 .43.35.77.77.77.42 0 .77-.35.77-.77v-2.37c3.43-.37 6.1-3.16 6.1-6.53a.77.77 0 0 0-.77-.77c-.42 0-.77.35-.77.77 0 2.77-2.39 5.03-5.33 5.03-1.13 0-2.17-.34-3.03-.91l1.05-1.05c.58.35 1.25.56 1.97.56l.01-.01ZM15.85 5.83c-.2-1.95-1.84-3.49-3.85-3.49a3.9 3.9 0 0 0-3.89 3.89v5.53c0 .53.11 1.04.31 1.5l7.43-7.43Z"
      fill={color}
    />
  </Svg>
)

export default MicOffFilled
